// extracted by mini-css-extract-plugin
module.exports = {"gamesPageRoot":"GamesPage_gamesPageRoot__LfyfZ","embedded":"GamesPage_embedded__S5q90"};